import conf from './Config';
import axios from 'axios';
import _ from 'lodash';

let dymo = window.dymo;

const frontendShippingItemURL = (id) => `${conf.FRONTEND_URL}/shipping-item/${id}`;

const PHONE_NO_WITH_PREFIX_RE = /^[+](\d{1,4})-([\d\s]{3,})$/;

function normalizeMatchPath(obj) {
	return obj.props.match.path.replace(/[/]$/,'');
}

function checkPrintingSanity(items, opts) {
	opts = opts || {};
	let errors = [];
	items.forEach( (item, ndx) => {
		if (!item.deliveryNoteId || !item.deliveryNoteDate || !item.client || !item.recipient || !item.attention
			|| !item.address || !item.zip || !item.city || !item.country
				|| !(item.grossWeight > 0) || !item.description || !item.packageSeq || !item.packagesTot
		){
			errors.push(`L'elemento con indice ${ndx+1} manca di campi obbligatori.`);
			console.log(item);
		}
	});
	if (opts.checkPackagesCompleteness) {
		//console.log(items);
		let groupedData = _.groupBy(items, (item => item.deliveryNoteId) );
		//console.log(groupedData);
		Object.keys(groupedData).forEach( key => {
			if (groupedData[key][0].packagesTot != groupedData[key].length) {
				errors.push(`Non hai selezionato tutti gli elementi della bolla ${key} oppure c'è una discrepanza tra il numero totale di pacchi e quelli effettivamente disponibili`);
			}
		});
	}

	return errors;
}

function getDymoPrinterAndLabel() {
	let info = {};
	return new Promise( (resolve, reject) => {
		axios.get(conf.DYMO_LABEL_URL).then( (response) => {
			info.labelTemplate = response.data;
			return dymo.label.framework.getPrintersAsync();
			//return [{ printerType: 'LabelWriterPrinter', name: 'pippo'}];
		}).then( (printers) => {
			if (printers.length == 0){
				throw new Error("Nessuna stampante DYMO trovata. Installala o avvia il suo software.");
			}
			console.log(printers);
			var printerName = "";
			for (var i = 0; i < printers.length; ++i)
			{
				var printer = printers[i];
				if (printer.printerType == "LabelWriterPrinter")
				{
					printerName = printer.name;
					break;
				}
			}

			if (printerName == ""){
				throw new Error("Nessuna stampante LabelWriter trovata. Installa una stampante LabelWriter");
			}

			info.printerName = printerName;
		}).then( () => {
			resolve(info);
		}).catch( (err) => {
			reject(err);
		});
	});
}

function dymoPrintLabel({ labelXml, printerName }) {
	let label = dymo.label.framework.openLabelXml(labelXml);
	return label.printAsync(printerName);
}

export { 
	normalizeMatchPath
	,frontendShippingItemURL
	,checkPrintingSanity
	,getDymoPrinterAndLabel
	,dymoPrintLabel
	,PHONE_NO_WITH_PREFIX_RE
};
